export class PlatexSendMessageRequest {
  constructor(public contextId: string, public message: string) {}
}
